import { Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAuthState } from '../../store/selectors';
import { Subscription } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';

@Directive({
    selector: '[appToggleDisplayRole]',
})
export class ToggleDisplayRoleDirective implements OnInit, OnDestroy {
    @Input() accessRole: Array<string>;
    @Input() hideElem = false;
    @Input() errorMessage = 'You do not have the correct role to access this feature. Please contact your administrator.';
    @Output() callFunction: EventEmitter<any> = new EventEmitter<any>();
    private hasRole = false;
    private readonly subscription: Subscription = new Subscription();
    constructor(private store: Store, private elemRef: ElementRef, private renderer: Renderer2, private toastService: ToastrService) {}

    @HostListener('click', ['$event'])
    onInput(e: any) {
        if (!this.hasRole) {
            this.toastService.error(this.errorMessage);
            e.stopImmediatePropagation();
            return false;
        } else {
            this.callFunction.emit();
        }
    }

    ngOnInit() {
        this.subscription.add(
            this.store
                .select(selectAuthState)
                .pipe(filter(() => this.elemRef.nativeElement !== undefined))
                .subscribe((auth) => {
                    if (this.hideElem) {
                        if (this.hasRole) {
                            this.renderer.setStyle(this.elemRef.nativeElement, 'visibility', 'visible');
                        } else {
                            this.renderer.setStyle(this.elemRef.nativeElement, 'visibility', 'hidden');
                        }
                    }
                })
        );
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
